// navigation titles specific to en-US
export default {
  // keys here should match the ones used in pages definePage style or uni.setNavigationBarTitle
  'tabbar.i18n': 'I18n',
  'i18n.title': 'En Title',

  'test': 'test',
};
